import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from "@angular/router";
import { Observable } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class SupportedBrowserGuard {
	constructor(private router: Router) {}

	canActivate(
		_next: ActivatedRouteSnapshot,
		_state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const ua = window.navigator.userAgent;
		const msie = ua.indexOf("MSIE ");
		const trident = ua.indexOf("Trident/");
		if (msie > -1 || trident > -1) {
			return this.router.parseUrl("error/418");
		}
		return true;
	}
}
